// WHAT CAN BE DONE TO ONE ROW — one primary act, the rest behind "עוד".
//
// The same acts the current screen offers (ChargeActions and the month buttons), with the
// same conditions: pay while there is a balance, cancel only while nothing is collected,
// the installments once something is. Every act opens the SAME dialog the current screen
// opens (BoardDialogs), so recording from here writes exactly what recording there does.
//
// Laid out differently on purpose: the old row showed three or four equal buttons, and a
// row whose every action shouts is a row whose next step you have to work out.
import { useState } from 'react';
import he from '../../i18n/he';
import Button from '../../components/Button';

const t = he.collections.board;
const p = he.moneyScreen.item;

function MoreMenu({ items }) {
  const [open, setOpen] = useState(false);
  if (items.length === 0) return null;
  return (
    <span className="mp-more">
      <Button small variant="subtle" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
        {p.more} ▾
      </Button>
      {open && (
        <>
          <span className="mp-more-scrim" onClick={() => setOpen(false)} />
          <span className="mp-more-menu" role="menu">
            {items.map((it) => (
              <button key={it.label} type="button" role="menuitem"
                onClick={() => { setOpen(false); it.onClick(); }}>
                {it.label}
              </button>
            ))}
          </span>
        </>
      )}
    </span>
  );
}

export default function RowActions({ kind, card, row, month, acts }) {
  if (kind === 'recorded') {
    const paid = Number(row.paid) > 0;
    // A project's own charge follows the project's price (068): it is changed on the
    // project, never cancelled here — the server refuses that too.
    const cancellable = row.origin !== 'auto_project';
    const more = [
      { label: t.correct, onClick: () => acts.onCorrect(card, row) },
      ...(paid ? [{ label: t.payments, onClick: () => acts.onPayments(card, row) }] : []),
      ...(!paid && cancellable ? [{ label: t.cancelCharge, onClick: () => acts.onCancel(card, row) }] : []),
    ];
    return (
      <span className="mp-actions">
        {row.collectible && (
          <Button small onClick={() => acts.onPay(card, row)}>{t.recordPayment}</Button>
        )}
        <MoreMenu items={more} />
      </span>
    );
  }
  if (kind === 'bill_month') {
    return (
      <span className="mp-actions">
        <Button small onClick={() => acts.onRecordMonth(card, month)}>{t.recordInvoice}</Button>
        <MoreMenu items={[{ label: t.skip, onClick: () => acts.onSkip(card, month) }]} />
      </span>
    );
  }

  if (kind === 'skipped') {
    return (
      <span className="mp-actions">
        <Button small variant="subtle" onClick={() => acts.onUnskip(card, month)}>{t.unskip}</Button>
      </span>
    );
  }
  if (kind === 'charge') {
    return (
      <span className="mp-actions">
        <Button small onClick={() => acts.onRaise(card, row)}>{t.recordCharge}</Button>
      </span>
    );
  }
  return null;
}
